module.exports = __webpack_public_path__ + "static/media/error404.c831ac40.jpg";